import { getConvertRouter } from "../utils/getConvertRouterReal";
window.hzeroGetConvertRouter = getConvertRouter;